import React from 'react';
import './Badge.css';

/**
 * Badge Component
 * Displays a status badge with color variants
 * 
 * @param {string} variant - Badge variant: 'success'|'warning'|'error'|'info'|'neutral'
 * @param {string} status - Status text (alternative to variant for color mapping)
 * @param {ReactNode} children - Badge content
 * @param {string} className - Additional CSS classes
 */
const Badge = ({
  variant,
  status,
  children,
  className = ''
}) => {
  // Map status strings to variants if status is provided
  const getVariant = () => {
    if (variant) return variant;
    if (!status) return 'neutral';
    
    const statusLower = status.toLowerCase();
    if (['ready', 'active', 'success', 'completed'].includes(statusLower)) return 'success';
    if (['warning', 'pending', 'provisioning', 'scaling'].includes(statusLower)) return 'warning';
    if (['error', 'failed', 'deleting', 'inactive'].includes(statusLower)) return 'error';
    if (['info', 'processing'].includes(statusLower)) return 'info';
    return 'neutral';
  };

  const badgeVariant = getVariant();
  const displayText = children || status || '';

  return (
    <span className={`badge badge-${badgeVariant} ${className}`.trim()}>
      {displayText}
    </span>
  );
};

export default Badge;
